import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-950 border-t border-navy-700 py-12" data-id="element-168">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-169">
        <div className="flex items-center gap-2" data-id="element-170">
          <span className="w-8 h-8 rounded bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center text-sm font-bold text-navy-900" data-id="element-171">
            TS
          </span>
          <span className="text-lg font-bold tracking-tighter text-white" data-id="element-172">
            Tom Schrepferman
          </span>
        </div>

        <div className="flex items-center gap-4" data-id="element-173">
          <a href="https://www.linkedin.com/in/tomschrepferman" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-navy-800 border border-navy-700 flex items-center justify-center text-white/50 hover:text-gold hover:border-gold/40 transition-colors" aria-label="LinkedIn" data-id="element-174">
            <Linkedin className="w-5 h-5" data-id="element-175" />
          </a>
          <a href="mailto:tom@hyroadconsulting.com" className="w-10 h-10 rounded-full bg-navy-800 border border-navy-700 flex items-center justify-center text-white/50 hover:text-gold hover:border-gold/40 transition-colors" aria-label="Email" data-id="element-176">
            <Mail className="w-5 h-5" data-id="element-177" />
          </a>
        </div>

        <div className="text-sm text-white/40 text-center md:text-right" data-id="element-178">
          <p data-id="element-179">
            &copy; {new Date().getFullYear()} Tom Schrepferman. All rights
            reserved.
          </p>
          <p className="mt-1" data-id="element-180">Senior Revenue Executive & Fractional CRO</p>
        </div>
      </div>
    </footer>;
}